module.exports = __webpack_public_path__ + "static/sample-projects-5-b72e769069bab4c95e0aea4d21571b4b.png";